import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  background-color: white;
  box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  flex-flow: column-reverse;
  margin-top: 24px;
  margin-bottom: 24px;

  @media ${minBp('tablet')} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Content = styled.div`
  padding: 24px;

  @media ${minBp('tablet')} {
    flex: 1;
    min-height: 150px;
  }
`;

export const Title = styled.h3`
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 5px;
  position: relative;
  text-transform: uppercase;
`;

export const InfoIconBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 6px;
  position: absolute;
  width: 18px;
  height: 18px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media ${minBp('desktop')} {
    margin-left: 10px;
  }
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0;
`;

export const ImageWrap = styled.div`
  width: 100%;
  height: 184px;

  @media ${minBp('tablet')} {
    position: relative;
    width: calc(100% / 3);
    height: initial;

    picture {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  @media ${minBp('desktop')} {
    width: 150px;
    height: 150px;

    picture {
      position: relative;
    }
  }

  img {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  }
`;
